import { jsx as s, jsxs as $, Fragment as j } from "react/jsx-runtime";
import { IconNames as x } from "@blueprintjs/icons";
import { Select as K, MultiSelect as C, Suggest as Q } from "@blueprintjs/select";
import { Button as H } from "@strata/react-buttons";
import J from "classnames";
import { MenuItem as P, Button as U, Intent as A, Icon as I } from "@blueprintjs/core";
import { conditionalString as X, getValidationMessage as M } from "@strata/helper-functions";
import "./main.scss";
import { FormFieldWrapper as O } from "@strata/react-form-field-wrapper";
import { Field as L } from "formik";
import { useState as Y, useEffect as Z, useRef as q } from "react";
function g(e) {
  if (typeof e == "string" || typeof e == "number")
    return `${e}`;
  const r = X(!!e.secondaryData, ` - ${e.secondaryData}`);
  return `${e.name}${r}`;
}
function B(e) {
  return typeof e == "string" || typeof e == "number" ? e : e.name;
}
const W = (e, r, l, i) => {
  const m = g(r).toString().toLowerCase(), p = e.toString().toLowerCase();
  return i ? m === p : m.includes(p);
}, T = (e, { modifiers: r, handleClick: l }, i = !1) => /* @__PURE__ */ s(
  P,
  {
    active: r.active,
    text: B(e),
    onClick: l,
    label: typeof e == "object" && e.secondaryData ? `${e.secondaryData}` : void 0,
    shouldDismissPopover: i,
    disabled: typeof e == "object" && e.disabled
  },
  g(e)
), h = (e, r, l) => /* @__PURE__ */ s(P, { active: r, text: e, onClick: l, shouldDismissPopover: !0 }, e), V = ({ isLoading: e = !1 }) => /* @__PURE__ */ s(P, { disabled: !0, text: e ? "Loading..." : "No results." }), fe = ({
  disabled: e = !1,
  values: r = [],
  onChange: l,
  onBlur: i = void 0,
  selectedItem: m = void 0,
  isLoading: p = !1,
  small: u = !1
}) => /* @__PURE__ */ s(
  K,
  {
    className: J("sds_simple-select", { "sds_simple-select--small": u }),
    disabled: e,
    onItemSelect: l,
    items: r,
    itemRenderer: (S, N) => T(S, N, !0),
    filterable: !1,
    popoverProps: {
      portalClassName: "sds_select__popover__portal",
      popoverClassName: "sds_select__popover",
      onClosing: i
    },
    noResults: /* @__PURE__ */ s(V, { isLoading: p }),
    children: /* @__PURE__ */ s(
      H,
      {
        iconAfterLabel: x.CARET_DOWN,
        label: g(m ?? "--"),
        disabled: e
      }
    )
  }
), z = ({ disabled: e, onClick: r }) => e ? null : /* @__PURE__ */ s(
  U,
  {
    className: "sds_select__clear-button",
    icon: x.CROSS,
    minimal: !0,
    onClick: r
  }
), ee = ({
  id: e,
  name: r,
  disabled: l = !1,
  values: i = [],
  label: m = "",
  helperText: p,
  inline: u = !1,
  fill: S,
  required: N = !1,
  requiredValidationMessage: y,
  verticalSpacingSmall: f = !1,
  autoFocus: R = !1,
  tabIndex: F,
  inputRef: v,
  placeholderText: E = "",
  onChange: c = void 0,
  onBlur: a = void 0,
  selectedItems: o = [],
  isLoading: _ = !1
}) => /* @__PURE__ */ s(
  O,
  {
    label: m,
    labelFor: e,
    disabled: l,
    helperText: p,
    inline: u,
    fill: S,
    required: N,
    requiredValidationMessage: y,
    verticalSpacingSmall: f,
    inputContent: /* @__PURE__ */ s(
      C,
      {
        className: "sds_select",
        disabled: l,
        placeholder: E,
        fill: !0,
        items: i.filter(
          (t) => !o.some((d) => g(d) === g(t))
        ),
        selectedItems: o,
        onItemSelect: (t) => c == null ? void 0 : c([...o, t]),
        resetOnSelect: !0,
        itemRenderer: T,
        itemPredicate: W,
        tagRenderer: g,
        popoverProps: {
          portalClassName: "sds_select__popover__portal",
          popoverClassName: "sds_select__popover",
          onClosing: a
        },
        tagInputProps: {
          disabled: l,
          inputRef: v,
          intent: y ? A.DANGER : void 0,
          onRemove: c ? (t) => c(o.filter((d) => g(d) !== t)) : void 0,
          onKeyDown: (t) => {
            t.key === "Enter" && t.preventDefault();
          },
          rightElement: /* @__PURE__ */ $(j, { children: [
            o.length > 0 && /* @__PURE__ */ s(
              z,
              {
                disabled: l,
                onClick: (t) => {
                  a == null || a(t.currentTarget), c == null || c([]);
                }
              }
            ),
            /* @__PURE__ */ s(
              I,
              {
                className: "sds_select__down-arrow",
                icon: x.CARET_DOWN,
                size: 16
              }
            )
          ] }),
          tagProps: {
            minimal: !0,
            multiline: !0
          },
          inputProps: {
            id: e,
            name: r,
            autoFocus: R,
            tabIndex: F
          }
        },
        noResults: /* @__PURE__ */ s(V, { isLoading: _ })
      }
    )
  }
), _e = ({
  id: e,
  disabled: r,
  values: l,
  label: i,
  helperText: m,
  inline: p,
  fill: u,
  required: S,
  requiredValidationMessage: N,
  verticalSpacingSmall: y,
  autoFocus: f,
  tabIndex: R,
  inputRef: F,
  placeholderText: v,
  onChange: E,
  onBlur: c,
  selectedItems: a,
  isLoading: o,
  validate: _ = void 0
}) => /* @__PURE__ */ s(L, { name: e, validate: _, children: ({ field: t, form: d }) => /* @__PURE__ */ s(
  ee,
  {
    id: t.name,
    name: t.name,
    values: l,
    isLoading: o,
    onChange: E ?? ((w) => d.setFieldValue(t.name, w)),
    onBlur: c ?? (() => d.setFieldTouched(t.name)),
    selectedItems: a ?? t.value,
    disabled: r,
    label: i,
    helperText: m,
    inline: p,
    fill: u,
    required: S,
    requiredValidationMessage: N ?? M(t.name, d),
    verticalSpacingSmall: y,
    placeholderText: v,
    autoFocus: f,
    tabIndex: R,
    inputRef: F
  }
) }), te = ({
  id: e,
  name: r,
  disabled: l = !1,
  values: i = void 0,
  createNewItemFromQuery: m,
  label: p = "",
  placeholderText: u = void 0,
  helperText: S,
  inline: N = !1,
  fill: y,
  required: f = !1,
  requiredValidationMessage: R,
  verticalSpacingSmall: F = !1,
  disableAutoPopulate: v = !1,
  autoFocus: E = !1,
  tabIndex: c,
  inputRef: a = void 0,
  onChange: o = void 0,
  onBlur: _ = void 0,
  selectedItem: t = null,
  isLoading: d = !1,
  itemsEqual: w
}) => {
  const [D, k] = Y("");
  Z(() => {
    !v && !t && f && (i == null ? void 0 : i.length) === 1 && (o == null || o(i[0]));
  }, [v, t, f, i, o]);
  const b = q(null);
  return /* @__PURE__ */ s(
    O,
    {
      label: p,
      labelFor: e,
      disabled: l,
      helperText: S,
      inline: N,
      fill: y,
      required: f,
      requiredValidationMessage: R,
      verticalSpacingSmall: F,
      inputContent: /* @__PURE__ */ s(
        Q,
        {
          className: "sds_select",
          disabled: l,
          fill: !0,
          onItemSelect: (n) => o == null ? void 0 : o(n),
          items: i ?? [],
          itemRenderer: (n, G) => T(n, G, !0),
          itemPredicate: W,
          itemsEqual: w,
          inputValueRenderer: g,
          createNewItemFromQuery: m,
          createNewItemRenderer: m && h,
          query: D,
          onQueryChange: (n) => k(n),
          popoverProps: {
            portalClassName: "sds_select__popover__portal",
            popoverClassName: "sds_select__popover",
            onClosing: _,
            onClosed: () => k("")
          },
          inputProps: {
            id: e,
            name: r,
            autoFocus: E,
            tabIndex: c,
            inputRef: (n) => {
              typeof a == "function" ? a(n) : a && typeof a == "object" && (a.current = n), b.current = n;
            },
            placeholder: u,
            intent: R ? A.DANGER : void 0,
            rightElement: /* @__PURE__ */ $(j, { children: [
              !f && t && /* @__PURE__ */ s(
                z,
                {
                  disabled: l,
                  onClick: (n) => {
                    _ == null || _(n.currentTarget), o == null || o(void 0);
                  }
                }
              ),
              /* @__PURE__ */ s(
                I,
                {
                  className: "sds_select__down-arrow",
                  icon: x.CARET_DOWN,
                  size: 16,
                  onClick: () => {
                    var n;
                    return (n = b.current) == null ? void 0 : n.focus();
                  }
                }
              )
            ] }),
            onKeyDown: (n) => {
              n.key === "Enter" && n.preventDefault();
            }
          },
          noResults: /* @__PURE__ */ s(V, { isLoading: d }),
          selectedItem: t
        }
      )
    }
  );
}, ue = ({
  id: e,
  disabled: r,
  values: l,
  createNewItemFromQuery: i,
  label: m,
  placeholderText: p,
  helperText: u,
  inline: S,
  fill: N,
  required: y,
  requiredValidationMessage: f,
  verticalSpacingSmall: R,
  disableAutoPopulate: F,
  autoFocus: v,
  tabIndex: E,
  inputRef: c,
  onChange: a,
  onBlur: o,
  selectedItem: _,
  isLoading: t,
  itemsEqual: d,
  validate: w = void 0
}) => /* @__PURE__ */ s(L, { name: e, validate: w, children: ({ field: D, form: k }) => /* @__PURE__ */ s(
  te,
  {
    id: D.name,
    name: D.name,
    values: l,
    createNewItemFromQuery: i,
    isLoading: t,
    onChange: a ?? ((b) => k.setFieldValue(D.name, b)),
    onBlur: o ?? (() => k.setFieldTouched(D.name)),
    selectedItem: _ ?? D.value,
    disabled: r,
    label: m,
    placeholderText: p,
    helperText: u,
    inline: S,
    fill: N,
    required: y,
    requiredValidationMessage: f ?? M(D.name, k),
    verticalSpacingSmall: R,
    disableAutoPopulate: F,
    autoFocus: v,
    tabIndex: E,
    inputRef: c,
    itemsEqual: d
  }
) });
export {
  fe as SimpleSelect,
  ee as SuggestMultiSelect,
  _e as SuggestMultiSelectFormik,
  te as SuggestSingleSelect,
  ue as SuggestSingleSelectFormik
};
//# sourceMappingURL=index.js.map
